import createParseMiddleware from './createParseMiddleware';
import { parseUserResponse } from 'utils/apiParser/userParser';
import { parseRoleResponse } from 'utils/apiParser/roleParser';
import { User } from 'types/userTypes';
import { Role } from 'types/roleTypes';

export const parseFetchUsersMiddleware = createParseMiddleware<User>(parseUserResponse, 'users/fetchUsers');
export const parseDescribeUserMiddleware = createParseMiddleware<User>(parseUserResponse, 'users/describeUser');
export const parseFetchSelectedUserRolesMiddleware = createParseMiddleware<Role>(parseRoleResponse, 'users/fetchSelectedUserRoles');